import Vue from 'vue';
var fullLoadingConfig = Vue.observable({
  isLoading: false,
  label: '',
  useRequestSpinner: false
});
export default fullLoadingConfig;